<template>
  <div id="app">
    <header-nav v-if="!$route.meta.hideHeader" :is-bule="$route.meta.isBule"></header-nav>
    <router-view></router-view>
    <footer-nav v-if="!$route.meta.hideFooter"></footer-nav>
  </div>
</template>

<script>
import footerNav from './components/footer.vue';
import headerNav from './components/header.vue';
export default {
  name: 'App',
  components: { footerNav,headerNav },
}
</script>

<style>
*{
  margin: 0;
  box-sizing: border-box;
}
::-webkit-scrollbar:horizontal {
  height: 12px; /* 保持横向滚动条正常高度 */
}
::-webkit-scrollbar-thumb {
border-radius: 10px;
-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
background-color: #8b8b8b;
}
::-webkit-scrollbar {
   width: 0;  /* 将竖向滚动条宽度设为0 */
  height: auto; /* 横向滚动条保持正常 */
  /* display: none; */
}

html {
  overflow-x: auto;
}

body {
  min-width: 1200px;
  overflow-x: auto;
  width: 100vw;
}

</style>
